import { UserSortOption, UserStatus } from '@rematter/frontend-lib-api-client';

import { simpleUserFragment } from './fragmentsUser';

import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';
import { QueryAtomResult } from '~/shared/providers/api/createQueryAtomFactory';

export type UserListRecord = QueryAtomResult<
  typeof userListQueryAtom
>['users'][number];

export const userListQueryAtom = createQueryAtomFactory(
  'admin.users',
  (params: {
    organizationId?: string;
    searchTerm?: string;
    status?: UserStatus | null;
    sortBy?: UserSortOption | null;
    pagination?: {
      limit: number;
      offset: number;
    };
  }) => ({
    users: {
      __args: {
        filter: {
          organizationId: params.organizationId,
          searchTerm: params.searchTerm,
          status: params.status || undefined,
        },
        sorting: params.sortBy ? [params.sortBy] : undefined,
        pagination: params.pagination,
      },
      entries: simpleUserFragment,
      page: {
        total: true,
      },
    },
  }),
  {
    select: ({ users }) => ({
      total: users.page.total ?? 0,
      users: users.entries,
    }),
  },
);
